module.exports = __webpack_public_path__ + "media/src/assets/images/property_photo6-94bdbe0b825c9b25b41e270882a73fc9.jpg";